import { type QueryClient, useQueryClient } from "@tanstack/react-query";
import { type PropsWithChildren } from "react";
import { WS_EVENT_TYPES } from "utils";

import { useEventSubscription, useOnWSReconnect } from "src/events";
import { getNotificationsQueryKey } from "src/queries/notifications";

function invalidateNotificationCaches(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: getNotificationsQueryKey() });
}

export function NotificationsRealtimeProvider(props: PropsWithChildren) {
  const queryClient = useQueryClient();

  useEventSubscription(WS_EVENT_TYPES.NOTIFICATION_ADDED, () => {
    invalidateNotificationCaches(queryClient);
  });

  useEventSubscription(WS_EVENT_TYPES.NOTIFICATION_READ, () => {
    invalidateNotificationCaches(queryClient);
  });

  useOnWSReconnect(() => {
    invalidateNotificationCaches(queryClient);
  });

  return <>{props.children}</>;
}
